import React, { useMemo } from "react";
import Select from "react-select";
import { useFormikContext, ErrorMessage } from "formik";
import { useProductList } from "../services/redux/api/components";

const ProductDropdown = ({
  name = "productId",
  pageNumber = 1,
  pageSize = 10000,
  onProductSelect,
  onChange,
}) => {
  const { setFieldValue, values } = useFormikContext();
  const { data: apiResponse, isLoading, isFetching, error } = useProductList(
    pageNumber,
    pageSize
  );

  // ✅ Normalize product list
  const rowData = useMemo(() => {
    if (!apiResponse?.data || !Array.isArray(apiResponse.data)) return [];
    return apiResponse.data.map((item) => ({
      ...item,
      id: item.ProductID ?? item.productID ?? item.id ?? item.productId,
      label: item.ProductName ?? `#${item.ProductID ?? ""}`,
      value: item.ProductID ?? item.productID ?? item.id ?? item.productId,
    }));
  }, [apiResponse]);

  const selectedValue =
    rowData.find((p) => String(p.value) === String(values[name])) || null;

  const handleChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    setFieldValue(name, value);

    if (onChange) onChange(value);

    if (onProductSelect) {
      const selectedProduct = rowData.find((p) => p.value === value);
      onProductSelect(selectedProduct);
    }
  };

  return (
    <div className="px-2">
      <label className="form-label">Product</label>

      <Select
        name={name}
        options={rowData}
        value={selectedValue}
        onChange={handleChange}
        isSearchable
        isClearable
        isLoading={isLoading || isFetching}
        placeholder={isLoading || isFetching ? "Loading products..." : "Select"}
        styles={{
          control: (base, state) => ({
            ...base,
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
            border: state.isFocused ? "1px solid #EB2B21" : "1px solid #D1D5DB",
            borderRadius: "10px",
            padding: "2px 2px",
            fontSize: "14px",
            outline: "none",
            "&:hover": {
              borderColor: state.isFocused ? "#EB2B21" : "#9ca3af",
            },
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
            borderRadius: "10px",
            boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.15)",
          }),
        }}
      />

      {error && (
        <div className="text-red-600 text-sm mt-1">
          Error loading products
        </div>
      )}
      <ErrorMessage
        name={name}
        component="div"
        className="text-red-600 text-sm mt-1"
      />
    </div>
  );
};

export default ProductDropdown;
